export * from "./ErrorMessage";
export * from "./LoveLetter";
export * from "./SessionId";
export * from "./StreamInfo";
export * from "./Stats";
export * from "./Ping";
export * from "./Queue";
export * from "./Version";
export * from "./WebSdkSettings";

import { ZStats } from "./Stats";

export const Send = {
  stats: ZStats,
};

export type Send = "onVideoInitialized";
